/**
 * What someone sees when their role doesn't include a page — e.g. Staff
 * following a link to /settings. The server refuses the data too; this only
 * makes the refusal readable. docs/PERMISSIONS.md.
 */
import { useNavigate } from '@tanstack/react-router'
import { Lock } from 'lucide-react'
import { Page } from '@/components/page'
import { type Role, roleLabels } from '@/core/access'
import { EmptyState } from './data-states'
import { startPageTitle } from './not-found'

export function NoAccess({ role }: { role: Role }) {
  const navigate = useNavigate()
  return (
    <Page>
      <EmptyState
        icon={Lock}
        title="This page is for admins"
        description={`You're signed in as ${roleLabels[role]}. Ask an admin in your workspace if you need something changed here.`}
        action={{ label: `Go to ${startPageTitle}`, onClick: () => navigate({ to: '/' }) }}
      />
    </Page>
  )
}
